import React, { useState } from 'react';
import useApi from '../../hooks/useApi';

const TestRulesButton = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [testResults, setTestResults] = useState(null);
    const [error, setError] = useState(null);

    const { postMe } = useApi();

    const runTests = async (rulesToTest = []) => {
        setIsLoading(true);
        setError(null);
        setTestResults(null);

        try {
            const response = await postMe('test', {
                testType: 'rules',
                rulesToTest: rulesToTest
            });

            // Handle different response structures
            const data = response.data || response;
            setTestResults(data);
        } catch (err) {
            setError(err.response?.data?.error || err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const runAllTests = () => runTests([]);
    const runSpecificTest = (ruleName) => runTests([ruleName]);

    return (
        <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', margin: '20px' }}>
            <h3>Rules Testing</h3>

            <div style={{ marginBottom: '20px' }}>
                <button
                    onClick={runAllTests}
                    disabled={isLoading}
                    style={{
                        padding: '10px 20px',
                        marginRight: '10px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isLoading ? 'not-allowed' : 'pointer'
                    }}
                >
                    {isLoading ? 'Running Tests...' : 'Run All Tests'}
                </button>

                <button
                    onClick={() => runSpecificTest('bookInvoice')}
                    disabled={isLoading}
                    style={{
                        padding: '10px 20px',
                        marginRight: '10px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isLoading ? 'not-allowed' : 'pointer'
                    }}
                >
                    Test Book Invoice
                </button>

                <button
                    onClick={() => runSpecificTest('bookStockAdjustment')}
                    disabled={isLoading}
                    style={{
                        padding: '10px 20px',
                        marginRight: '10px',
                        backgroundColor: '#17a2b8',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isLoading ? 'not-allowed' : 'pointer'
                    }}
                >
                    Test Stock Adjustment
                </button>

                <button
                    onClick={() => runSpecificTest('bookStockMovement')}
                    disabled={isLoading}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#6f42c1',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isLoading ? 'not-allowed' : 'pointer'
                    }}
                >
                    Test Stock Movement
                </button>
            </div>

            {error && (
                <div style={{
                    padding: '10px',
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    border: '1px solid #f5c6cb',
                    borderRadius: '4px',
                    marginBottom: '20px'
                }}>
                    <strong>Error:</strong> {error}
                </div>
            )}

            {testResults && (
                <div style={{
                    padding: '15px',
                    backgroundColor: testResults.success ? '#d4edda' : '#f8d7da',
                    color: testResults.success ? '#155724' : '#721c24',
                    border: `1px solid ${testResults.success ? '#c3e6cb' : '#f5c6cb'}`,
                    borderRadius: '4px'
                }}>
                    <h4>Test Results</h4>
                    <p><strong>Summary:</strong> {testResults.summary}</p>
                    <p><strong>Success Rate:</strong> {testResults.results.successRate}</p>
                    <p><strong>Timestamp:</strong> {new Date(testResults.timestamp).toLocaleString()}</p>

                    <details style={{ marginTop: '10px' }}>
                        <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                            View Detailed Results ({testResults.results.tests.length} tests)
                        </summary>
                        <div style={{ marginTop: '10px' }}>
                            {testResults.results.tests.map((test, index) => (
                                <div
                                    key={index}
                                    style={{
                                        padding: '8px',
                                        margin: '5px 0',
                                        backgroundColor: test.success ? '#e8f5e8' : '#ffe8e8',
                                        border: `1px solid ${test.success ? '#c3e6cb' : '#f5c6cb'}`,
                                        borderRadius: '4px'
                                    }}
                                >
                                    <strong>{test.ruleName}:</strong>
                                    <span style={{ color: test.success ? 'green' : 'red', marginLeft: '10px' }}>
                                        {test.success ? '✅ PASSED' : '❌ FAILED'}
                                    </span>
                                    {test.testType && (
                                        <span style={{
                                            marginLeft: '10px',
                                            fontSize: '0.8em',
                                            backgroundColor: test.testType === 'live' ? '#007bff' : '#6c757d',
                                            color: 'white',
                                            padding: '2px 6px',
                                            borderRadius: '3px'
                                        }}>
                                            {test.testType === 'live' ? 'LIVE DATA' : 'STATIC DATA'}
                                        </span>
                                    )}
                                    {test.validationsPassed && (
                                        <span style={{ marginLeft: '10px', fontSize: '0.9em' }}>
                                            ({test.validationsPassed} validations passed)
                                        </span>
                                    )}
                                    {test.testDataId && (
                                        <div style={{ marginTop: '3px', fontSize: '0.8em', color: '#666' }}>
                                            Tested with ID: {test.testDataId}
                                        </div>
                                    )}
                                    {test.error && (
                                        <div style={{ marginTop: '5px', fontSize: '0.9em', color: '#721c24' }}>
                                            Error: {test.error}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </details>
                </div>
            )}
        </div>
    );
};

export default TestRulesButton;
